// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"fae6a384","592":"766d8165"}[chunkId] + ".chunk.css";
};